import { render, staticRenderFns } from "./PluginList.vue?vue&type=template&id=4969de69&scoped=true"
import script from "./PluginList.vue?vue&type=script&lang=js"
export * from "./PluginList.vue?vue&type=script&lang=js"
import style0 from "./PluginList.vue?vue&type=style&index=0&id=4969de69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4969de69",
  null
  
)

export default component.exports